import { Upload, Wand2, MessageCircle, Hammer } from "lucide-react";

const steps = [
  { icon: Upload, n: "01", title: "Unggah Foto", desc: "Foto ruangan eksisting dari sudut terbaik." },
  { icon: Wand2, n: "02", title: "Pilih Gaya", desc: "Modern, Japandi, Klasik Modern, dan lainnya." },
  { icon: MessageCircle, n: "03", title: "Konsultasi", desc: "Diskusi gratis dengan desainer profesional kami." },
  { icon: Hammer, n: "04", title: "Build", desc: "Kami eksekusi desain hingga ruangan siap huni." },
];

export default function Process() {
  return (
    <section id="proses" data-testid="process-section" className="relative py-24 lg:py-32 px-6 lg:px-12 bg-gradient-to-b from-cyan-50/40 to-white">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-8">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-sky-600 mb-4 font-semibold">Cara Kerja</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter leading-tight max-w-2xl text-slate-900">
              Empat langkah menuju<br />
              <span className="italic text-sky-600">ruangan impian</span> Anda.
            </h2>
          </div>
          <p className="text-slate-600 max-w-md font-light">
            Dari foto sederhana hingga eksekusi pembangunan — semua kami tangani dalam satu studio terintegrasi.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s) => (
            <div
              key={s.n}
              data-testid={`process-step-${s.n}`}
              className="group relative bg-white border border-sky-100 rounded-2xl p-8 hover:shadow-xl hover:shadow-sky-100 hover:border-sky-300 transition-all duration-500"
            >
              <div className="flex items-start justify-between mb-10">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-sky-100 to-cyan-50 flex items-center justify-center">
                  <s.icon size={22} className="text-sky-600" strokeWidth={1.5} />
                </div>
                <span className="font-display text-4xl text-slate-200 group-hover:text-sky-200 transition-colors">
                  {s.n}
                </span>
              </div>
              <h3 className="font-display text-2xl font-medium mb-3 text-slate-900">{s.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
